<template>
    <b-container>
        <b-row v-if="file == null">
            <b-col>
                <h3>Carica il file CSV</h3>
                <b-alert show variant="info">
                    <i class="fas fa-info-circle"></i>&nbsp;Scarica il file CSV da Eventbrite come viene mostrato in questa guida:
                    <a href="https://www.fatturaelettronicapro.it/come-scaricare-la-lista-di-tutti-i-partecipanti-ad-un-evento-da-eventbrite/" target="_blank">Scopri come scaricare il file CSV da Eventbrite</a>
                </b-alert>
                <input type="file" @change="processingFile($event)" />
                <!-- <b-button variant="danger" @click="testFile()">CSV Test</b-button> -->
            </b-col>
        </b-row>

        <!--
    ..######...#######..##........#######..##....##.##....##.########
    .##....##.##.....##.##.......##.....##.###...##.###...##.##......
    .##.......##.....##.##.......##.....##.####..##.####..##.##......
    .##.......##.....##.##.......##.....##.##.##.##.##.##.##.######..
    .##.......##.....##.##.......##.....##.##..####.##..####.##......
    .##....##.##.....##.##.......##.....##.##...###.##...###.##......
    ..######...#######..########..#######..##....##.##....##.########
    -->

        <b-row v-if="header_table_options.length > 0 && rows_error <= 0 && rows_valid <= 0">
            <b-col>
                <h3>Configurazione colonne</h3>
                <b-alert show variant="info">
                    <i class="fas fa-info-circle"></i>&nbsp;Nel menu a tendina vengono mostrate tutte le colonne presenti nel file caricato, il sistema proverà a rilevare automaticamente quelle corrette, in caso di errori selezionare la colonna corrispondente.
                    <br />
                    <br />
                    <b>Codice Fiscale e Partita IVA:</b> se è stata usata la stessa colonna, selezionare la stessa colonna.<br />
                    <b>Ragione Sociale:</b> se non viene usata, lasciare vuota, verra utilizzato il nome e il cognome.<br />
                    <br />
                    <b>ATTENZIONE:</b> assicurati di aver scaricato il file corretto, controlla che nella prime colonne ci siano i dati: numero dell'ordine, data dell'ordine, nome, cognome, email, numero di biglietti acquistati. Se stai usando un file personalizzato seleziona le colonne corrispondenti ma ricorda che sono campi OBBLIGATORI.<br />
                </b-alert>

                <b-alert show variant="warning"> <i class="fas fa-info-circle"></i>&nbsp;Pulire il file CSV da tutte le colonne vuote e inserite automaticamente da Eventbrite, questo permette a Fattura Elettronica Pro di rilevare con più accuratezza le colonne </b-alert>

                <b-form-group :state="validation.colonna_id_order()" id="input-group-1" label="Numero ordine:" label-for="input-1">
                    <b-form-select :state="validation.colonna_id_order()" required id="input-1" v-model="index_from_csv.id_order" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_id_order()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_id_order()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_data()" id="input-group-1" label="Data ordine:" label-for="input-1">
                    <b-form-select :state="validation.colonna_data()" required id="input-1" v-model="index_from_csv.data" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_data()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_data()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_first_name()" id="input-group-1" label="Nome:" label-for="input-1">
                    <b-form-select :state="validation.colonna_first_name()" required id="input-1" v-model="index_from_csv.first_name" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_first_name()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_first_name()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_last_name()" id="input-group-1" label="Cognome:" label-for="input-1">
                    <b-form-select :state="validation.colonna_last_name()" required id="input-1" v-model="index_from_csv.last_name" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_last_name()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_last_name()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_email()" id="input-group-1" label="Email:" label-for="input-1">
                    <b-form-select :state="validation.colonna_email()" required id="input-1" v-model="index_from_csv.email" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_email()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_email()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_quantita_biglietto()" id="input-group-1" label="Quantità biglietti:" label-for="input-1">
                    <b-form-select :state="validation.colonna_quantita_biglietto()" required id="input-1" v-model="index_from_csv.quantita_biglietto" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_quantita_biglietto()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_quantita_biglietto()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_valore_biglietto()" id="input-group-1" label="Totale pagato:" label-for="input-1">
                    <b-form-select :state="validation.colonna_valore_biglietto()" required id="input-1" v-model="index_from_csv.valore_biglietto" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_valore_biglietto()">La colonna è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_valore_biglietto()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_ragionesociale()" id="input-group-1" label="Colonna Ragione Sociale:" label-for="input-1">
                    <b-form-select :state="validation.colonna_ragionesociale()" required id="input-1" v-model="index_from_csv.ragionesociale" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna della Ragione Sociale, se non presente lascia non selezionata --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_ragionesociale()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_pec()" id="input-group-1" label="Colonna Indirizzo PEC:" label-for="input-1">
                    <b-form-select :state="validation.colonna_pec()" required id="input-1" v-model="index_from_csv.pec" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna dell'indirizzo PEC --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_pec()">La colonna Indirizzo PEC è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_pec()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_sdi()" id="input-group-2" label="Colonna Codice SDI:" label-for="input-2">
                    <b-form-select :state="validation.colonna_sdi()" required id="input-2" v-model="index_from_csv.sdi" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna del Codice SDI --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_sdi()">La colonna Codice SDI è obbligatoria per poter elaborare correttamente il file CSV</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_sdi()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_cf()" id="input-group-3" label="Colonna Codice Fiscale:" label-for="input-3">
                    <b-form-select :state="validation.colonna_cf()" required id="input-3" v-model="index_from_csv.cf" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna del Codice Fiscale --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_cf()">La colonna Codice Fiscale è obbligatoria per poter elaborare correttamente il file CSV, se hai usato una sola colonna con la Partita IVA seleziona la stessa</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_cf()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group :state="validation.colonna_piva()" id="input-group-3" label="Colonna Partita IVA:" label-for="input-3">
                    <b-form-select :state="validation.colonna_piva()" required id="input-3" v-model="index_from_csv.piva" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna della Partita IVA --</option>
                        </template>
                    </b-form-select>
                    <b-form-invalid-feedback :state="validation.colonna_piva()">La colonna Partita IVA è obbligatoria per poter elaborare correttamente il file CSV, se hai usato una sola colonna con la Codice Fiscale seleziona la stessa</b-form-invalid-feedback>
                    <b-form-valid-feedback :state="validation.colonna_piva()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label="Colonna del campo Via/Indirizzo di Fatturazione:" label-for="input-4" :state="validation.colonna_indirizzo()">
                    <b-form-select required :state="validation.colonna_indirizzo()" id="input-4" v-model="index_from_csv.indirizzo" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna dell'Indirizzo di fatturazione --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_indirizzo()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label="Colonna del campo Citta di Fatturazione:" label-for="input-4" :state="validation.colonna_indirizzo_citta()">
                    <b-form-select required :state="validation.colonna_indirizzo_citta()" id="input-4" v-model="index_from_csv.indirizzo_citta" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna della Città di fatturazione --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_indirizzo_citta()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label="Colonna del campo CAP (Codice Postale) di Fatturazione:" label-for="input-4" :state="validation.colonna_indirizzo_cap()">
                    <b-form-select required :state="validation.colonna_indirizzo_cap()" id="input-4" v-model="index_from_csv.indirizzo_cap" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna del CAP di fatturazione --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_indirizzo_cap()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label="Colonna del campo Provincia di Fatturazione:" label-for="input-4" :state="validation.colonna_indirizzo_provincia()">
                    <b-form-select required :state="validation.colonna_indirizzo_provincia()" id="input-4" v-model="index_from_csv.indirizzo_provincia" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna della Provincia di fatturazione --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_indirizzo_provincia()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-form-group id="input-group-4" label="Colonna del campo Nazione di Fatturazione:" label-for="input-4" :state="validation.colonna_indirizzo_nazione()">
                    <b-form-select required :state="validation.colonna_indirizzo_nazione()" id="input-4" v-model="index_from_csv.indirizzo_nazione" :options="header_table_options">
                        <template slot="first">
                            <option :value="null" disabled>-- Seleziona la colonna della Nazione di fatturazione --</option>
                        </template>
                    </b-form-select>
                    <b-form-valid-feedback :state="validation.colonna_indirizzo_nazione()">Ben fatto.</b-form-valid-feedback>
                </b-form-group>

                <b-alert class="mt-1" variant="warning" :show="!validation.colonna_indirizzo() || !validation.colonna_indirizzo_citta() || !validation.colonna_indirizzo_cap() || !validation.colonna_indirizzo_provincia() || !validation.colonna_indirizzo_nazione()">Se non hai richiesto l'indirizzo puoi comunque procedere con l'elaborazione ma fai attenzione a selezionare correttamente i filtri nel prossimo step</b-alert>
            </b-col>
        </b-row>

        <b-row class="mt-3" v-if="header_table_options.length > 0 && rows_error <= 0 && rows_valid <= 0">
            <b-col class="text-center">
                <b-button v-on:click="parseCSVtoTable()" variant="primary" size="lg"> <i class="fas fa-cogs"></i> Procedi con l'elaborazione dei dati </b-button>
            </b-col>
        </b-row>

        <b-row class="mt-3" v-if="header_table_options.length > 0 && rows_error <= 0 && rows_valid <= 0">
            <b-col class="text-center">
                <b-button outline size="sm" v-on:click="resetCSV()" variant="light"> <i class="far fa-trash-alt"></i> Ricarica il file </b-button>
            </b-col>
        </b-row>

        <!--
.########....###....########..########.##.......##..........###...
....##......##.##...##.....##.##.......##.......##.........##.##..
....##.....##...##..##.....##.##.......##.......##........##...##.
....##....##.....##.########..######...##.......##.......##.....##
....##....#########.##.....##.##.......##.......##.......#########
....##....##.....##.##.....##.##.......##.......##.......##.....##
....##....##.....##.########..########.########.########.##.....##
    -->
        <b-row v-if="rows_error > 0 || rows_valid > 0">
            <b-col>
                <h3>Elaborazione dati</h3>

                <b-alert v-if="errors_count > 0" show variant="danger">
                    <b>
                        <i class="fas fa-exclamation-triangle"></i>
                        {{ errors_count }}
                    </b>
                    Errori: controllare la tabella per verificare i dati mancanti, per aggiungeri i dati mancanti puoi modificare gli ordini su Eventbrite ed eseguire nuovamente la procedura. Oppure modifica i filtri per includere delle eccezioni sui dati mancanti.
                    <br />
                    <br />
                    <!-- CF missing  -->
                    <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[2].value" :value="filter_table_options[2].value" switch>{{ filter_table_options[2].text }}</b-form-checkbox>

                    <!-- PIVA missing  -->
                    <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[3].value" :value="filter_table_options[3].value" switch>{{ filter_table_options[3].text }}</b-form-checkbox>

                    <!-- Indirizzo missing  -->
                    <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[4].value" :value="filter_table_options[4].value" switch>{{ filter_table_options[4].text }}</b-form-checkbox>
                </b-alert>

                <b-alert v-if="warnings_count > 0" show variant="warning">
                    <b>
                        <i class="fas fa-exclamation-triangle"></i>
                        {{ warnings_count }}
                    </b>
                    Avvertimenti: alcune righe presentano dati mancanti ma importanti per una corretta fatturazione, le righe con soli avvertimenti vengono comunque considerate valide, utilizzando i filtri si possono include o escludere dalla fatturazione
                    <br />
                    <br />
                    <!-- Free tickets warning  -->
                    <b-form-checkbox v-if="filter_table_options_selected.indexOf('free_tickets') >= 0" v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[1].value" :value="filter_table_options[1].value" switch>{{ filter_table_options[1].text }}</b-form-checkbox>
                    <!-- Indirizzi warning  -->
                    <b-form-checkbox v-if="filter_table_options_selected.indexOf('address_missing') >= 0" v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[5].value" :value="filter_table_options[5].value" switch>{{ filter_table_options[5].text }}</b-form-checkbox>
                </b-alert>

                <b-alert v-if="free_tickets > 0 && filter_table_options_selected.indexOf('free_tickets') == -1" show variant="info">
                    <b>
                        <i class="fas fa-info-circle"></i>
                        {{ free_tickets }}
                    </b>
                    Biglietti gratuiti: è possibile aggiungere i biglietti gratuiti nella fatturazione spuntando l'opzione corrispondente al passo precedente, in alcuni casi è richiesta la fatturazione anche dei biglietti gratuiti, puoi approfondire leggendo questo articolo [link articolo]
                    <br />
                    <br />
                    <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[0].value" :value="filter_table_options[0].value" switch>{{ filter_table_options[0].text }}</b-form-checkbox>
                </b-alert>

                <b-alert show variant="info"> <i class="fas fa-info-circle"></i>&nbsp;Modifica le colonne e/o i filtri per ottenere un'elaborazione dei dati in base alle tue esigenze </b-alert>
            </b-col>
        </b-row>

        <b-row v-if="rows_error > 0 || rows_valid > 0" class="mt-3">
            <b-col>
                <b-button disabled size="lg" variant="outline-primary" block>
                    <i class="fas fa-ticket-alt"></i> Biglietti
                    <b-badge variant="primary">{{ totale_biglietti }}</b-badge>
                </b-button>
            </b-col>
            <b-col>
                <b-button disabled size="lg" variant="outline-primary" block>
                    <i class="fas fa-ticket-alt"></i> Biglietti gratuiti
                    <b-badge variant="primary">{{ free_tickets }}</b-badge>
                </b-button>
            </b-col>
            <b-col>
                <b-button disabled size="lg" variant="outline-success" block>
                    <i class="fas fa-check text-success"></i> Ordini validi
                    <b-badge variant="success">{{ rows_valid }}</b-badge>
                </b-button>
            </b-col>
            <b-col>
                <b-button disabled size="lg" variant="outline-danger" block>
                    <i class="fas fa-exclamation-triangle text-danger"></i> Ordini con errori
                    <b-badge variant="danger">{{ rows_error }}</b-badge>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-if="rows_error > 0 || rows_valid > 0" class="mt-3">
            <!-- Biglietti -->
            <b-col>
                <b-button disabled size="lg" variant="outline-primary" block>
                    <i class="fas fa-users"></i> Ordini
                    <b-badge variant="primary">{{ totale_ordini }}</b-badge>
                </b-button>
                <br>
                <!-- Causale ordine  -->
                <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[6].value" :value="filter_table_options[6].value" switch>{{ filter_table_options[6].text }}</b-form-checkbox>
            </b-col>

            <!-- Biglietti gratuiti  -->
            <b-col>
                <!-- Free tickets  -->
                <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[0].value" :value="filter_table_options[0].value" switch>{{ filter_table_options[0].text }}</b-form-checkbox>

                <!-- Free tickets warning  -->
                <b-form-checkbox v-if="filter_table_options_selected.indexOf('free_tickets') >= 0" v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[1].value" :value="filter_table_options[1].value" switch>{{ filter_table_options[1].text }}</b-form-checkbox>
            </b-col>

            <!-- Ordini Validi -->
            <b-col>
                <!-- Indirizzi warning  -->
                <b-form-checkbox v-if="filter_table_options_selected.indexOf('address_missing') >= 0" v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[5].value" :value="filter_table_options[5].value" switch>{{ filter_table_options[5].text }}</b-form-checkbox>
            </b-col>

            <!-- Ordini con errori  -->
            <b-col>
                <!-- CF missing  -->
                <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[2].value" :value="filter_table_options[2].value" switch>{{ filter_table_options[2].text }}</b-form-checkbox>

                <!-- PIVA missing  -->
                <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[3].value" :value="filter_table_options[3].value" switch>{{ filter_table_options[3].text }}</b-form-checkbox>

                <!-- Indirizzo missing  -->
                <b-form-checkbox v-model="filter_table_options_selected" name="filter-options" :key="filter_table_options[4].value" :value="filter_table_options[4].value" switch>{{ filter_table_options[4].text }}</b-form-checkbox>
            </b-col>
        </b-row>

        <b-row class="mt-3 justify-content-center" v-if="rows_error > 0 || rows_valid > 0">
            <b-col cols="6" class="text-center">
                <b-button v-if="filter_settings_changed" v-on:click="parseCSVtoTable()" block variant="warning" size="lg"> <i class="fas fa-cogs"></i> Filtri e impostazioni cambiati, riprocessare i dati </b-button>

                <b-button v-if="!filter_settings_changed" v-on:click="parseCSVtoTable()" block variant="outline-primary" size="lg"> <i class="fas fa-cogs"></i> Elabora i dati </b-button>
            </b-col>
        </b-row>

        <b-row class="mt-3" v-if="rows_error > 0 || rows_valid > 0">
            <b-col class="text-center">
                <b-button outline size="sm" v-on:click="resetCSV()" variant="light"> <i class="far fa-trash-alt"></i> Ricarica il file </b-button>
            </b-col>
        </b-row>

        <!--

.########.########..########...#######..########..####...
.##.......##.....##.##.....##.##.....##.##.....##..##....
.##.......##.....##.##.....##.##.....##.##.....##..##....
.######...########..########..##.....##.########...##....
.##.......##...##...##...##...##.....##.##...##....##....
.##.......##....##..##....##..##.....##.##....##...##....
.########.##.....##.##.....##..#######..##.....##.####...

    -->
        <b-row v-if="rows_error > 0" class="mt-5">
            <b-col>
                <h3>
                    <i class="fas fa-exclamation-triangle text-danger"></i>&nbsp;Ordini con errori
                    <br />
                    <small>{{ rows_error }} righe con errori</small>
                </h3>
            </b-col>
            <b-col cols="2">
                <b-button v-if="mostra_rows_error" variant="outline-danger" block @click="toggleErrorTable"> <i class="far fa-window-close"></i>&nbsp;Chiudi </b-button>
            </b-col>
        </b-row>

        <b-row class="justify-content-center" v-if="rows_error > 0 && !mostra_rows_error">
            <b-col cols="6" class="text-center">
                <b-button v-if="!mostra_rows_error" variant="danger" @click="toggleErrorTable"> <i class="fas fa-table"></i>&nbsp;Mostra la tabella con gli Errori </b-button>
            </b-col>
        </b-row>

        <b-row v-if="rows_error > 0 && mostra_rows_error">
            <b-col>
                <csv-items-table-eventbrite v-bind:table="table_error"></csv-items-table-eventbrite>
            </b-col>
        </b-row>

        <!--
.##.....##....###....##.......####.########..####
.##.....##...##.##...##........##..##.....##..##.
.##.....##..##...##..##........##..##.....##..##.
.##.....##.##.....##.##........##..##.....##..##.
..##...##..#########.##........##..##.....##..##.
...##.##...##.....##.##........##..##.....##..##.
....###....##.....##.########.####.########..####
    -->
        <b-row v-if="rows_valid > 0" class="mt-5">
            <b-col>
                <h3>
                    <i class="fas fa-check text-success"></i>&nbsp;Ordini validi
                    <br />
                    <small>{{ rows_valid }} righe valide</small>
                </h3>
            </b-col>
            <b-col cols="2">
                <b-button v-if="mostra_rows_valid" variant="outline-danger" block @click="toggleValidTable"> <i class="far fa-window-close"></i>&nbsp;Chiudi </b-button>
            </b-col>
        </b-row>

        <b-row class="justify-content-center" v-if="rows_valid > 0 && !mostra_rows_valid">
            <b-col cols="6">
                <b-button v-if="!mostra_rows_valid" variant="success" block @click="toggleValidTable"> <i class="fas fa-table"></i>&nbsp;Mostra la tabella con le fatture valide </b-button>
            </b-col>
        </b-row>

        <b-row v-if="rows_valid > 0 && mostra_rows_valid">
            <b-col>
                <csv-items-table-eventbrite v-bind:table="table_valid"></csv-items-table-eventbrite>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import Papa from "papaparse";

export default {
    props: [],
    mounted() {},
    data() {
        return {
            table_fields: [{ key: "index", label: "#" }, "id_order", { key: "name", label: "Full Name" }, "email", { key: "quantita_biglietto", label: "Biglietti" }, "actions", { key: "errors", label: "" }],
            totale_biglietti: 0,
            totale_ordini: 0,
            table_error: [],
            table_valid: [],
            mostra_rows_error: false,
            mostra_rows_valid: false,
            header_table: [],
            header_table_options: [],
            filter_table_options: [
                {
                    text: "Includi i biglietti gratuiti",
                    value: "free_tickets",
                },
                {
                    text: "Nascondi avvisi per biglietti gratuiti",
                    value: "disable_free_tickets_warning",
                },
                {
                    text: "Includi gli ordini con Codice Fiscale mancante",
                    value: "cf_missing",
                },
                {
                    text: "Includi gli ordini con Partita IVA mancante",
                    value: "piva_missing",
                },
                {
                    text: "Includi gli ordini con l'indirizzo mancante o incompleto",
                    value: "address_missing",
                },
                {
                    text: "Nascondi gli avvisi legati ai biglietti con indirizzi mancanti",
                    value: "disable_address_missing_warning",
                },
                {
                    text: "Non usare la causale precompilata con numero biglietti e numero ordine",
                    value: "disable_causale_precompilata_eventbrite",
                },
            ],
            filter_table_options_selected: [],
            filter_table_options_selected_processed: [],
            event_name: "Eventbrite",
            errors_count: 0,
            warnings_count: 0,
            free_tickets: 0,
            iva_perc: 0.22,
            file: null,
            index_from_csv: {
                id_order: -1,
                data: -1,
                first_name: -1,
                last_name: -1,
                email: -1,
                quantita_biglietto: -1,
                valore_biglietto: -1,
                ragionesociale: -1,
                sdi: -1,
                pec: -1,
                cf: -1,
                piva: -1,
                indirizzo: -1,
                citta: -1,
                cap: -1,
                provincia: -1,
                nazione: -1,
            },
            file_test:
                "Ordine n.;Data ordine;Nome;Cognome;E-mail;Quantità;Tipologia biglietto;Tipo ordine;Totale pagato;Commissioni Eventbrite;Processore di Pagamenti Eventbrite;Stato partecipante;Indirizzo PEC;Codice Destinatario (SDI);P.IVA e Codice Fiscale;Indirizzo di fatturazione 1;Indirizzo di fatturazione 2;Città fatturazione;Stato fatturazione;Codice postale della fatturazione;Paese fatturazione\n940506293;2019-04-26 11:08:07+02:00;Enrico;Rossomando;billing@alpaca.team;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506294;2019-04-26 11:08:07+02:00;Pippo;Pluto;pippo@pluto.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506295;2019-04-26 11:08:07+02:00;Paperino;Pluto;paperino@disney.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506296;2019-04-26 11:08:07+02:00;Mamma;Papera;mammapapera@disney.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506297;2019-04-26 11:08:07+02:00;Tony;Stark;tony@starkindustries.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506293;2019-04-26 11:08:07+02:00;Enrico;Rossomando;billing@alpaca.team;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506294;2019-04-26 11:08:07+02:00;Pippo;Pluto;pippo@pluto.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506295;2019-04-26 11:08:07+02:00;Paperino;Pluto;paperino@disney.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506296;2019-04-26 11:08:07+02:00;Mamma;Papera;mammapapera@disney.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n940506297;2019-04-26 11:08:07+02:00;Tony;Stark;tony@starkindustries.it;1;Biglietto a pagamento;Ordine a pagamento;10;1,22;0,22;Partecipante;indirizzo@pec.it;M5UXCR1;12345678900;Viale Antonio Gramsci, 85;;Montoro;Avellino;83025;Italia\n",
        };
    },
    methods: {
        processingFile: function (event) {
            let self = this;

            this.file = event.target.files[0];

            Papa.parse(this.file, {
                complete: function (results) {
                    let table = [];
                    let index = 0;
                    self.errors_count = 0;
                    self.warnings_count = 0;
                    self.free_tickets = 0;
                    self.event_name = "";

                    for (let e in results.data) {
                        // salvo l'header
                        if (index == 0) {
                            self.header_table = results.data[e];
                        }

                        break;
                    }

                    self.parseCSVHeader();
                },
            });
        },
        testFile: function () {
            let self = this;

            this.file = this.file_test;

            Papa.parse(this.file, {
                complete: function (results) {
                    let table = [];
                    let index = 0;
                    self.errors_count = 0;
                    self.warnings_count = 0;
                    self.free_tickets = 0;
                    self.event_name = "";

                    for (let e in results.data) {
                        // salvo l'header
                        if (index == 0) {
                            self.header_table = results.data[e];
                        }

                        break;
                    }

                    self.parseCSVHeader();
                },
            });
        },
        resetCSV() {
            this.table_error = [];
            this.table_valid = [];
            this.header_table = [];
            this.header_table_options = [];
            this.filter_table_options_selected = [];
            this.filter_table_options_selected_processed = [];
            this.currentPage_error = 1;
            this.currentPage_valid = 1;
            this.errors_count = 0;
            this.warnings_count = 0;
            this.totale_biglietti = 0;
            this.totale_ordini = 0;
            this.file = null;
            this.free_tickets = 0;
            this.index_from_csv = {
                id_order: -1,
                data: -1,
                first_name: -1,
                last_name: -1,
                email: -1,
                quantita_biglietto: -1,
                ticket_type: -1,
                order_type: -1,
                valore_biglietto: -1,
                ragionesociale: -1,
                sdi: -1,
                pec: -1,
                cf: -1,
                piva: -1,
                indirizzo: -1,
                citta: -1,
                cap: -1,
                provincia: -1,
                nazione: -1,
            };
            this.$emit("data-ready", null);
            this.$emit("select-row", null);
        },
        parseCSVHeader() {
            // Setto i valori di default del file di Eventbrite
            this.index_from_csv.id_order = 0;
            this.index_from_csv.data = 1;
            this.index_from_csv.first_name = 2;
            this.index_from_csv.last_name = 3;
            this.index_from_csv.email = 4;
            this.index_from_csv.quantita_biglietto = 5;

            for (let i in this.header_table) {
                let text = this.header_table[i];

                this.header_table_options.push({
                    text: text,
                    value: i,
                });

                // cerco eventuali corrispondenze automatiche
                if (text.search(/Tipologia biglietto/i) >= 0 || text.search(/Ticket Type/i) >= 0) {
                    this.index_from_csv.ticket_type = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/Tipo ordine/i) >= 0 || text.search(/Order Type/i) >= 0) {
                    this.index_from_csv.order_type = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/Totale pagato/i) >= 0 || text.search(/Total Paid/i) >= 0) {
                    this.index_from_csv.valore_biglietto = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/ragione/i) >= 0 || text.search(/company/i) >= 0) {
                    this.index_from_csv.ragionesociale = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/sdi/i) >= 0 || text.search(/codice destinatar/i) >= 0) {
                    this.index_from_csv.sdi = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/pec/i) >= 0) {
                    this.index_from_csv.pec = i;
                    continue;
                }
                // cerco eventuali corrispondenze automatiche
                if (text.search(/billing address 1/i) >= 0) {
                    this.index_from_csv.indirizzo = i;
                    continue;
                }
                // cerco eventuali corrispondenze automatiche
                if (text.search(/fiscale/i) >= 0) {
                    this.index_from_csv.cf = i;
                    this.index_from_csv.piva = i;
                    //   continue; // Non continuo perché potrei sovrascrivere la partita IVA con un campo più appropiato
                }
                // cerco eventuali corrispondenze automatiche
                if (text.search(/iva/i) >= 0) {
                    this.index_from_csv.piva = i;
                    continue;
                }
                // cerco eventuali corrispondenze automatiche
                if (text.search(/via/i) >= 0 || text.search(/indirizzo/i) >= 0 || text.search(/indirizzo di fatturazione 1/i) >= 0) {
                    this.index_from_csv.indirizzo = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/citt/i) >= 0) {
                    this.index_from_csv.indirizzo_citta = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/cap/i) >= 0 || text.search(/codice post/i) >= 0) {
                    this.index_from_csv.indirizzo_cap = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/prov/i) >= 0) {
                    this.index_from_csv.indirizzo_provincia = i;
                    continue;
                }

                // cerco eventuali corrispondenze automatiche
                if (text.search(/nazione/i) >= 0) {
                    this.index_from_csv.indirizzo_nazione = i;
                    continue;
                }
            }
        },
        parseCSVtoTable() {
            let self = this;

            this.filter_table_options_selected_processed = this.filter_table_options_selected;

            Papa.parse(this.file, {
                complete: function (results) {
                    let table_error = [];
                    let table_valid = [];
                    let table = [];
                    let index = 0;
                    self.errors_count = 0;
                    self.warnings_count = 0;
                    self.event_name = "";
                    self.free_tickets = 0;
                    self.totale_ordini = 0;
                    self.totale_biglietti = 0;

                    for (let e in results.data) {
                        // salvo l'header
                        if (index == 0) {
                            self.header_table = results.data[e];
                        }

                        // salvo le righe della tabella
                        if (index > 0) {
                            let item = self.checkParseData(results.data[e]);

                            if (item !== false) {
                                table.push(item);

                                if (item.errori_fatturazione.length > 0) {
                                    table_error.push(item);
                                } else {
                                    table_valid.push(item);
                                }
                            }
                        }

                        index++;
                    }

                    self.table_error = table_error;
                    self.table_valid = table_valid;

                    self.$emit("data-ready", table);

                    if (table_valid.length > 0) self.$emit("select-row", table_valid[0]);
                },
            });
        },
        checkParseData(row) {
            if (row.length < 8) return false;

            let tableRow = {
                nome_evento: "",
                id_order: "",
                data: "",
                first_name: "",
                last_name: "",
                nome: "",
                email: "",
                valore_biglietto: 0,
                iva_biglietto: 0,
                quantita_biglietto: "",
                order_type: "",
                ticket_type: "",
                fatturazione: {
                    info: "",
                    indirizzo: "",
                    indirizzo_2: "",
                    citta: "",
                    provincia: "",
                    cap: "",
                    nazione: "",
                    pec: "",
                    sdi: "",
                    cf: "",
                    piva: "",
                    causale: "",
                },
                errori_fatturazione: [],
                warning: [],
            };

            if (parseInt(this.index_from_csv.id_order) >= 0 && row[this.index_from_csv.id_order].length >= 0) {
                tableRow.id_order = row[this.index_from_csv.id_order];
            }

            if (parseInt(this.index_from_csv.data) > 0 && row[this.index_from_csv.data].length > 0) {
                tableRow.data = row[this.index_from_csv.data];
            }

            if (parseInt(this.index_from_csv.first_name) > 0 && row[this.index_from_csv.first_name].length > 0) {
                tableRow.first_name = row[this.index_from_csv.first_name];
            }

            if (parseInt(this.index_from_csv.last_name) > 0 && row[this.index_from_csv.last_name].length > 0) {
                tableRow.last_name = row[this.index_from_csv.last_name];
            }

            tableRow.nome = tableRow.first_name + " " + tableRow.last_name;

            if (parseInt(this.index_from_csv.email) > 0 && row[this.index_from_csv.email].length > 0) {
                tableRow.email = row[this.index_from_csv.email];
            }

            if (parseInt(this.index_from_csv.quantita_biglietto) > 0 && row[this.index_from_csv.quantita_biglietto].length > 0) {
                tableRow.quantita_biglietto = row[this.index_from_csv.quantita_biglietto];
            }

            if (parseInt(this.index_from_csv.ticket_type) > 0 && row[this.index_from_csv.ticket_type].length > 0) {
                tableRow.ticket_type = row[this.index_from_csv.ticket_type];
            }

            if (parseInt(this.index_from_csv.order_type) > 0 && row[this.index_from_csv.order_type].length > 0) {
                tableRow.order_type = row[this.index_from_csv.order_type];
            }

            if (parseInt(this.index_from_csv.valore_biglietto) > 0 && row[this.index_from_csv.valore_biglietto].length > 0) {
                tableRow.valore_biglietto = parseFloat(row[this.index_from_csv.valore_biglietto]);
            }

            if (parseInt(this.index_from_csv.pec) > 0 && row[this.index_from_csv.pec].length > 0) {
                tableRow.fatturazione.pec = row[this.index_from_csv.pec];
            }

            if (parseInt(this.index_from_csv.sdi) > 0 && row[this.index_from_csv.sdi].length > 0) {
                tableRow.fatturazione.sdi = row[this.index_from_csv.sdi];
            }

            if (parseInt(this.index_from_csv.cf) > 0 && row[this.index_from_csv.cf].length > 0) {
                tableRow.fatturazione.cf = row[this.index_from_csv.cf];
            }

            if (parseInt(this.index_from_csv.piva) > 0 && row[this.index_from_csv.piva].length > 0) {
                tableRow.fatturazione.piva = row[this.index_from_csv.piva];
            }

            if (parseInt(this.index_from_csv.ragionesociale) > 0 && row[this.index_from_csv.ragionesociale].length > 0) {
                tableRow.nome = row[this.index_from_csv.ragionesociale];
            }

            if (parseInt(this.index_from_csv.indirizzo) > 0) {
                tableRow.fatturazione.indirizzo = row[this.index_from_csv.indirizzo];
            }

            // tableRow.fatturazione.indirizzo_2 = row[this.index_from_csv.indirizzo_extra];

            if (parseInt(this.index_from_csv.indirizzo_citta) > 0) {
                tableRow.fatturazione.citta = row[this.index_from_csv.indirizzo_citta];
            }

            if (parseInt(this.index_from_csv.indirizzo_provincia) > 0) {
                tableRow.fatturazione.provincia = row[this.index_from_csv.indirizzo_provincia];
            }

            if (parseInt(this.index_from_csv.indirizzo_cap) > 0) {
                tableRow.fatturazione.cap = row[this.index_from_csv.indirizzo_cap];
            }

            if (parseInt(this.index_from_csv.indirizzo_nazione) > 0) {
                tableRow.fatturazione.nazione = row[this.index_from_csv.indirizzo_nazione];
            }

            if (this.filter_table_options_selected.indexOf("disable_causale_precompilata_eventbrite") == -1) {
                tableRow.fatturazione.causale = tableRow.quantita_biglietto + " biglietti (Order no. " + tableRow.id_order + ")";
            }
            else {
                tableRow.fatturazione.causale = "";
            }

            // conto i biglietti totali
            if (tableRow.quantita_biglietto && tableRow.quantita_biglietto > 0) {
                this.totale_biglietti += parseInt(tableRow.quantita_biglietto);
            }

            // conto i singoli ordini
            this.totale_ordini++;

            // calcolo l'IVA del biglietto
            if (tableRow.valore_biglietto > 0) {
                tableRow.iva_biglietto = Math.round((tableRow.valore_biglietto - tableRow.valore_biglietto / (1 + this.iva_perc)) * 100) / 100;
            } else {
                this.free_tickets++;

                if (this.filter_table_options_selected.indexOf("disable_free_tickets_warning") == -1) {
                    tableRow.warning.push({
                        field: "valore_biglietto",
                        msg: "Biglietto gratuito, controllare i filtri per includere o escludere questa tipologia di biglietti",
                    });
                }

                if (this.filter_table_options_selected.indexOf("free_tickets") == -1) return false;
            }

            if (!tableRow.first_name || tableRow.first_name.length <= 2) {
                tableRow.errori_fatturazione.push({
                    field: "first_name",
                    msg: "Nome non valido",
                });
            }

            if (!tableRow.last_name || tableRow.last_name.length <= 2) {
                tableRow.errori_fatturazione.push({
                    field: "last_name",
                    msg: "Cognome non valido",
                });
            }

            // se la colonna del Codice Fiscale e Partita IVA sono uguali, devo riempire solo uno dei due campi
            if (this.index_from_csv.cf == this.index_from_csv.piva) {
                // diamo precedenza alla partita IVA
                if (tableRow.fatturazione.piva && tableRow.fatturazione.piva.length >= 9 && tableRow.fatturazione.piva.length < 16) {
                    tableRow.fatturazione.cf = null;
                } else {
                    tableRow.fatturazione.piva = null;
                }
            }

            let cf_valido = false;
            let piva_valida = false;

            if (tableRow.fatturazione.cf && tableRow.fatturazione.cf.length >= 16) {
                cf_valido = true;
            }

            if (tableRow.fatturazione.piva && tableRow.fatturazione.piva.length >= 9) {
                piva_valida = true;
            }

            if (!cf_valido && !piva_valida) {
                if (this.filter_table_options_selected.indexOf("cf_missing") != -1) {
                    // aggiungo il Codice fiscale per Estero
                    tableRow.fatturazione.cf = "99999999999";
                    cf_valido = true;
                } else {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.cf",
                        msg: "Codice fiscale e Partita IVA mancanti o errati",
                    });
                }
            } else {
                if (cf_valido && !piva_valida) {
                    if (typeof tableRow.fatturazione.sdi != "undefined" && tableRow.fatturazione.sdi.length <= 3) {
                        tableRow.fatturazione.sdi = "0000000";
                        tableRow.fatturazione.pec = "";
                    }
                }

                if (!cf_valido) {
                    // se non voglio includere i cf mancanti e la piva non è valida segnalo l'errore
                    if (this.filter_table_options_selected.indexOf("cf_missing") == -1 && !piva_valida) {
                        tableRow.errori_fatturazione.push({
                            field: "fatturazione.cf",
                            msg: "Codice fiscale mancante o errato",
                        });
                    }
                }

                if (!piva_valida) {
                    // se non voglio includere piva mancanti e il cf non è valido segnalo l'errore
                    if (this.filter_table_options_selected.indexOf("piva_missing") == -1 && !cf_valido) {
                        tableRow.errori_fatturazione.push({
                            field: "fatturazione.piva",
                            msg: "Partita IVA mancante o errata",
                        });
                    }
                }
            }

            if (!tableRow.fatturazione.indirizzo || tableRow.fatturazione.indirizzo.length <= 2) {
                if (this.filter_table_options_selected.indexOf("address_missing") == -1) {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.indirizzo",
                        msg: "Indirizzo di fatturazione non valido",
                    });
                } else {
                    if (this.filter_table_options_selected.indexOf("disable_address_missing_warning") == -1) {
                        tableRow.warning.push({
                            field: "fatturazione.indirizzo",
                            msg: "Indirizzo di fatturazione non valido",
                        });
                    }
                }
            }

            if (!tableRow.fatturazione.citta || tableRow.fatturazione.citta.length <= 2) {
                if (this.filter_table_options_selected.indexOf("address_missing") == -1) {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.citta",
                        msg: "citta di fatturazione non valido",
                    });
                } else {
                    if (this.filter_table_options_selected.indexOf("disable_address_missing_warning") == -1) {
                        tableRow.warning.push({
                            field: "fatturazione.citta",
                            msg: "citta di fatturazione non valido",
                        });
                    }
                }
            }

            if (!tableRow.fatturazione.provincia || tableRow.fatturazione.provincia.length < 2) {
                if (this.filter_table_options_selected.indexOf("address_missing") == -1) {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.provincia",
                        msg: "provincia di fatturazione non valido",
                    });
                } else {
                    if (this.filter_table_options_selected.indexOf("disable_address_missing_warning") == -1) {
                        tableRow.warning.push({
                            field: "fatturazione.provincia",
                            msg: "provincia di fatturazione non valido",
                        });
                    }
                }
            }

            if (!tableRow.fatturazione.cap || tableRow.fatturazione.cap.length < 5) {
                if (this.filter_table_options_selected.indexOf("address_missing") == -1) {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.cap",
                        msg: "cap di fatturazione non valido",
                    });
                } else {
                    if (this.filter_table_options_selected.indexOf("disable_address_missing_warning") == -1) {
                        tableRow.warning.push({
                            field: "fatturazione.cap",
                            msg: "cap di fatturazione non valido",
                        });
                    }
                }
            }

            if (!tableRow.fatturazione.nazione || tableRow.fatturazione.nazione.length < 2) {
                if (this.filter_table_options_selected.indexOf("address_missing") == -1) {
                    tableRow.errori_fatturazione.push({
                        field: "fatturazione.nazione",
                        msg: "nazione di fatturazione non valido",
                    });
                } else {
                    if (this.filter_table_options_selected.indexOf("disable_address_missing_warning") == -1) {
                        tableRow.warning.push({
                            field: "fatturazione.nazione",
                            msg: "nazione di fatturazione non valido",
                        });
                    }
                }
            }

            if (tableRow.warning.length > 0) {
                tableRow["_rowVariant"] = "warning";
                this.warnings_count++;
            }

            if (tableRow.errori_fatturazione.length > 0) {
                tableRow["_rowVariant"] = "danger";
                this.errors_count++;
            }

            return tableRow;
        },
        selectRow: function (row) {
            this.$emit("select-row", row.item);
        },
        toggleErrorTable: function (event) {
            this.mostra_rows_error = !this.mostra_rows_error;
        },
        toggleValidTable: function (event) {
            this.mostra_rows_valid = !this.mostra_rows_valid;
        },
    },
    watch: {},
    computed: {
        rows_error() {
            return this.table_error.length;
        },
        rows_valid() {
            return this.table_valid.length;
        },
        filter_settings_changed() {
            return JSON.stringify(this.filter_table_options_selected_processed) != JSON.stringify(this.filter_table_options_selected);
        },
        validation: function () {
            let self = this;
            return {
                colonna_id_order: function () {
                    return self.index_from_csv.id_order >= 0;
                },
                colonna_data: function () {
                    return self.index_from_csv.data >= 0;
                },
                colonna_first_name: function () {
                    return self.index_from_csv.first_name >= 0;
                },
                colonna_last_name: function () {
                    return self.index_from_csv.last_name >= 0;
                },
                colonna_email: function () {
                    return self.index_from_csv.email >= 0;
                },
                colonna_quantita_biglietto: function () {
                    return self.index_from_csv.quantita_biglietto >= 0;
                },
                colonna_valore_biglietto: function () {
                    return self.index_from_csv.valore_biglietto >= 0;
                },
                colonna_ragionesociale: function () {
                    return true;
                },
                colonna_pec: function () {
                    return self.index_from_csv.pec >= 0;
                },
                colonna_sdi: function () {
                    return self.index_from_csv.sdi >= 0;
                },
                colonna_cf: function () {
                    return self.index_from_csv.cf >= 0;
                },
                colonna_piva: function () {
                    return self.index_from_csv.piva >= 0;
                },
                colonna_indirizzo: function () {
                    return self.index_from_csv.indirizzo >= 0;
                },
                colonna_indirizzo_citta: function () {
                    return self.index_from_csv.indirizzo_citta >= 0;
                },
                colonna_indirizzo_cap: function () {
                    return self.index_from_csv.indirizzo_cap >= 0;
                },
                colonna_indirizzo_provincia: function () {
                    return self.index_from_csv.indirizzo_provincia >= 0;
                },
                colonna_indirizzo_nazione: function () {
                    return self.index_from_csv.indirizzo_nazione >= 0;
                },
            };
        },
    },
};
</script>
